<template>
  <div class="costContainer">
    <div class="costContent">
      <van-cell-group>
        <van-field v-model="carInfo.carBrand" label="车辆信息" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.driverName" label="驾驶员" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.driverPhone" label="司机电话" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.departTime" label="发车时间" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.comebackTime" label="回场时间" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.useDuration" label="用车时长" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.startMileage" label="起始里程数" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.endMileage" label="终止里程数" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.realityMileage" label="实际行驶里程数" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.travelCost" label="行驶费用" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.roadBridgeCost" label="路桥费" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.otherCost" label="其他费用" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.totalCost" label="用车费用结算" readonly input-align="right" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="carInfo.remarks" rows="5" autosize label="备注" readonly type="textarea" input-align="right" />
      </van-cell-group>
    </div>
    <!-- <div style="padding: 10px 0 20px 0; display: flex; justify-content: center">
      <van-button @click="returnMyApply" type="default" size="small" style="width: 70%">返回</van-button>
    </div> -->
    <div class="footerBtn">
      <van-button @click="returnMyApply" type="default" size="small">取消</van-button>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/car.js";
import moment from "moment";
import "moment/locale/zh-cn";
export default {
  name: "costDetail",
  data() {
    return {
      carInfo: {
        peopleNum: "",
        marker: ""
      }
    };
  },
  mounted() {
    sessionStorage.removeItem('carInfo');
    console.log(this.$route.query.applyNumber);
    let applyNumber = this.$route.query.applyNumber;
    if (applyNumber) {
      this.postqueryCostDetails(applyNumber);
    }
  },
  methods: {
    //  时间
    comfirmArriveTime(value) {
      return moment(value).format("MM月DD日 dddd HH:mm");
    },
    returnMyApply() {
      this.$router.go(-1);
    },
    //查看费用详情
    postqueryCostDetails(applyNumber) {
      this.airportNameList = [];
      this.destinationList = [];
      console.log('applyNumber', applyNumber);
      apis.queryCostDetails({ applyNumber: applyNumber })
        .then((res) => {
          console.log('查看费用详情', res.data);
          let carInfo = res.data;
          carInfo.departTime ? carInfo.departTime = this.comfirmArriveTime(carInfo.departTime) : '';
          carInfo.comebackTime ? carInfo.comebackTime = this.comfirmArriveTime(carInfo.comebackTime) : '';
          let mileage = 0;

          mileage =
            Number(carInfo.endMileage) * 100 -
            Number(carInfo.startMileage) * 100;
          carInfo.realityMileage = (mileage / 100).toFixed(2);
          this.carInfo = carInfo;
        })
        .catch(() => {
          // this.$toast.fail('提交失败')
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .costContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .costContainer {
    width: 276px * $zoom;
  }
}

.costContainer {
  padding-top: 20px;

  background-color: #f3f3f5;

  .costContent {
    height: calc(100vh - 215px);
    overflow-y: auto;
    padding-bottom: 20px;
  }

  .footerBtn {
    width: 100%;
    // padding-top: 30px;
    background-color: #f7f9fa;
    display: flex;
    justify-content: center;

    ::v-deep(.van-button--small) {
      width: 100%;
      height: 88px;
      border-radius: 0;
      font-size: 27px;
      border: 0;
    }
  }
}
</style>
